import { useAnalyticsPageView } from '@cc-shopping/platform-analytics/AnalyticsPageView/Context';
import { FeatureViewed } from '@cc-shopping/platform-analytics/FeatureViewed';
import { useAnalytics } from '@cc-shopping/platform-analytics/hooks/useAnalytics';
import { usePageAction } from '@cc-shopping/platform-analytics/hooks/usePageAction';
import { useIdentityContext } from '@cc-shopping/platform-analytics/IdentityContext';
import { auth0 } from '@cc-shopping/platform-auth0';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useRef } from 'react';
import { useReviewContext } from 'src/app/credit-cards/reviews/components/Context';
import { v4 as uuid } from 'uuid';
export default function ReviewSignUp() {
  const {
    pageViewId,
    pageName,
    contentId,
    contentSource
  } = useAnalyticsPageView();
  const {
    deployableName,
    deployableVersion,
    analytics,
    deviceId
  } = useAnalytics();
  const {
    isLoggedIn
  } = useIdentityContext();
  const {
    showSignUpBanner
  } = useReviewContext();
  const activityId = useRef(uuid());
  const fireRegisterPageAction = usePageAction({
    actionName: 'review_register',
    parentActivityId: activityId.current
  });
  if (isLoggedIn || !showSignUpBanner) {
    return null;
  }
  const onClick = async () => {
    const currentURL = new URL(window.location.href);
    const urlWithoutSearchParams = `${currentURL.origin}${currentURL.pathname}`;
    const anonymousUserId = (await analytics?.segmentInstance?.user())?.anonymousId() || '';
    const options = {
      anonymousUserId,
      cancelUrl: urlWithoutSearchParams,
      deployableName,
      deployableVersion,
      driverContentId: String(contentId),
      driverContentSource: contentSource || '',
      driverElement: 'button',
      driverLocation: 'review_register',
      driverPageName: pageName || window.location.pathname,
      driverPageUrl: urlWithoutSearchParams,
      driverPageViewId: pageViewId,
      driverSubLocation: 'review_register',
      redirectTo: urlWithoutSearchParams,
      mostRecentTraditionalDeviceId: deviceId
    };
    const signUpUrl = auth0.generateAuthLink({
      initialScreen: 'signup',
      ...options
    });
    fireRegisterPageAction({
      action_type: 'open',
      target_page_url: signUpUrl
    });
    auth0.signUp(options);
  };
  return <FeatureViewed entityName="review_register" impressionPosition={3} activityId={activityId.current} entitySection="">
      <Grid container flexDirection={{
      xs: 'column',
      sm: 'row'
    }} p={{
      xs: 3,
      md: 4
    }} bgcolor="info.light" boxShadow={'0px 2px 2px 0px #40404040'} gap={{
      xs: 3,
      sm: 0
    }} data-testid="creditCardSignUpBanner">
        <Grid display="flex" flexDirection="column" size={{
        sm: 8
      }} pr={{
        xs: 2,
        sm: 3
      }}>
          <Typography variant="textBold" mb={1}>
            Get more smart money moves — straight to your inbox
          </Typography>
          <Typography variant="text">
            Become a NerdWallet member, and we&apos;ll send you tailored articles we think
            you&apos;ll love.
          </Typography>
        </Grid>
        <Grid size={{
        sm: 4
      }} alignItems="center" mt={{
        xs: 2,
        sm: 0
      }}>
          <Button onClick={onClick} sx={{
          letterSpacing: 1
        }}>
            SIGN UP NOW
          </Button>
        </Grid>
      </Grid>
    </FeatureViewed>;
}